/* eslint-disable @typescript-eslint/naming-convention */
export enum TimeFilter {
  None = 0,
  H1 = 1,
  H3 = 2,
  H6 = 3,
  H12 = 4,
  H24 = 5,
  Today = 6,
  D1 = 7,
  D2 = 8,
  D3 = 9,
  D4 = 10,
  D5 = 11,
  D6 = 13,
  Live = 12,
  All = 100,
  ResultToday = 70,
  ResultD1 = 71,
  ResultD2 = 72,
  ResultD3 = 73,
  ResultD4 = 74,
  ResultD5 = 75,
  ResultD6 = 76,
}

export enum TypeOfPlaceBetTicket {
  Standard = 1,
  Express = 2,
  FreeBet = 3
}



// export enum TimeFilter {
//   H1 = 1,
//   H3 = 3,
//   H6 = 6,
//   H12 = 12,
//   Today = 24,
//   D1 = +1,
//   D2 = +2,
//   D3 = +3,
//   D4 = +4,
//   D5 = +5,
//   All = 100,
// }

export enum EventMappingType {
  StandardEvent = 1,
  EventOfDay = 2,
  SuperBetEvent = 3,
  Live = 4,
  Special = 5,
  LuckyWinner = 6
}

export enum SpecialOfferType{
  EventOfDay = 2,
  SuperBet = 3,
  Outrights = 4
}

export enum BetTypeSelectionSBVSelectionType {
  None = null,
  MostBalanced = 1,
  Exact = 2,
}

export enum SBVSelectionType {
  All = 0,
  MostBalanced = 1,
  Exact = 2,
}

export enum BettingMode {
  None = 0,
  Prematch = 1,
  Live = 2,
  All = 3,
}

export enum MaxPayoutType {
  Absolute = 0,
  MaxTotalOdd = 1,
}

export enum OfficeNumberRounding {
  None = 0,
  WholeNumber = 1,
  HalfNumber = 2,
  OneDecimal = 3,
  TwoDecimal = 4,
  ThreeDecimal = 5,
  FourDecimal = 6
}

export enum PageType {
  Prematch = 'prematch',
  Live = 'live',
  Results = 'results',
  HomePage = 'homepage',
  MostPopular = 'mostpopular',
  // TodayOffer = 'todayoffer',
  Soon = 'soon',
  Help = 'help',
}

export enum TreeLevel {
  Sports = 0,
  Regions = 1,
  Competitions = 2,
}

export enum DaySpanResults {
  Today = 0,
  Yesterday = 1,
  Last3Days = 2,
  Last5Days = 4,
  Last7Days = 6,
}

export enum DeviceType {
  Android = 1,
  webOS = 2,
  iPhone = 3,
  iPad = 4,
  iPod = 5,
  BlackBerry = 6,
  WindowsPhone = 7,
  Other = 8,
}

export enum TicketTab {
  Ticket = 1,
  MyTickets = 2,
  FindTicket = 3,
}

export enum ScannerType {
  QRCode = 1,
  BarCode = 2,
}

export enum TicketFilterStatus {
  All = 1,
  Active = 2,
  Win = 3,
  Cashout = 4,
  Lost = 5,
  Storno = 6,
  Cashback = 7,
  Expired = 8,
  Paid = 9
}

export enum StreamType {
  Rtmp = 0,
  DashManifest = 1,
  CmafManifest = 2,
  Hls = 3,
  HlsManifest = 4,
}

export enum SportIcon {
  All = 0,
  Football = 1,
  Basketball = 2,
  Tennis = 3,
  IceHockey = 4,
  Baseball = 5,
  Handball = 6,
  Floorball = 7,
  Golf = 8,
  Boxing = 9,
  Moto = 10,
  Rugby = 11,
  AussieRules = 12,
  WinterSports = 13,
  Bandy = 14,
  AmericanFootball = 15,
  Snooker = 16,
  TableTennis = 17,
  Cricket = 18,
  Darts = 19,
  Volleyball = 20,
  FieldHockey = 21,
  WaterPolo = 22,
  Curling = 23,
  Futsal = 24,
  Badminton = 25,
  Bowls = 26,
  BeachVolley = 27,
  Squash = 28,
  BeachSoccer = 29,
  Pesapallo = 30,
  ESports = 32, // CS GO
  // ESports = 33, // LoL
  // ESports = 34, // DOta 2
  // ESports = 35, // Starcraft
  Fighting = 36,
  // ESports = 37,
  // ESports = 38,
  Cycling = 39,
  // IceHockey = 41,
  // WinterSports = 42,
  // WinterSports = 43,
  SkiJumping = 45,
  Special = 46,
  // Moto = 60,
  // ESports = 69, // Rocket League
  // ESports = 72, // Rainbow six
}

export enum SelectionChangeType {
  Sport = 1,
  Region = 2,
  Competition = 3,
}

export enum HierarchyType {
  Sport = 1,
  Region = 2,
  Competition = 3,
}

export enum EventHeaderTabType {
  Sport = 1,
  Region = 2,
  Competition = 3,
  RegionAndCompetitions = 4
}

export enum BetTypeOutcomeShowType {
  BTOFullName = 0,
  BTOShortName = 1,
  ParticipantName = 2,
  Custom = 3,
  None = 10
}

export enum SBVDisplayType {
  NoSbv = -1,
  SBVInBetType = 0,
  SBVInOutcome = 1,
  SBVAlone = 2
}

export enum BetTypeNameDisplayType {
  BetTypeNameSameRow = 1,
  BetTypeNameHeaderRow = 2
}

export enum BetOutcomeResult {
  Offline = 0,
  Online = 1,
  Void = 2,
  Replaced = 3,
  Passed = 6,
  Failed = 7,
  Pending = 11,
  HalfLose = 15,
  HalfWin = 16,
  Inactive = 17,
  Refund = 32
}

export enum BetOutcomeOddDifference {
  None = 0,
  Higher = 'higher',
  Lower = 'lower',
  LongHigher = 3,
  LongLower = 4,
  Higher2 = 'higher2',
  Lower2 = 'lower2',
  Other = 7,
}

export enum TaxBaseType {
  Winning = 1,
  NetWinning = 2
}

export enum OfficeDisplayNumberFormat {
  None = 0,
  OneDecimal = 1,
  TwoDecimal = 2,
  NoDecimals = 3
}

export enum TicketStatus {
  New = 1,
  //
  // Summary:
  //     Accepted
  Approved = 3,
  WaitingApproval = 4,
  Rejected = 5,
  Passed = 6,
  Failed = 7,
  Paid = 8,
  ConditionallyApproved = 9,
  ProcessingApproval = 10,
  Pending = 11,
  //
  // Summary:
  //     Used only at Back office UI (stakes manager)
  Open = 13,
  CustomerCancelled = 14,
  //
  // Summary:
  //     Used in BetAttendant when ticket is rejected because of TakeOverTimeout, TradeTimeOut
  //     or AcceptanceTimeout.
  AutomaticallyRejected = 17,
  Won = 18,
  WaitingForRecalculation = 19,
  Expired = 20,
  AutoRejectTakeOverTimeout = 21,
  AutoRejectTradeTimeout = 22,
  AutoRejectAcceptanceTimeout = 23,
  WaitingForPlatformAuthorization = 24,
  PlatformTicketRollback = 25,
  FastTicket = 26,
  FastTicketConditionalyApproved = 27,
  CashOut = 28,
  Void = 29,
  VoidPaid = 30,
  VoidExpired = 31,
  //
  // Summary:
  //     this will be Storno Status - old PaidVoid = 34,
  Storno = 34,
  CashBack = 35,
  CashBackPaid = 36,
  CashBackExpired = 37,
  //
  // Summary:
  //     Not in database, used just for communication trough wcf
  NotAuthorized = 100,
  //
  // Summary:
  //     Not in database, set in limit check
  Error = 200
}

export enum TicketRejectionReason {
  None = 0,
  BonusChanged = 1,
  InvalidEvents = 2,
  TicketItemsOddChange = 3,
  RestrictionValidationFailed = 4,
  LimitRiskRejection = 5,
  InactiveBetOutcome = 6,
  OfflineBets = 7,
  ClientServerCalculationsDiffer = 8,
  InvalidOdds = 9,
  BetCloneRejected = 10
}

export enum ErrorLevel {
  Notification = 0,
  Warning = 1,
  Fatal = 2,
  Success = 3
}

export enum ErrorType {
  ComunicationError = 0,
  Warning = 1,
  Fatal = 2,
  Authorization = 3,
  CloseDialog = 4,
  CasheOutChange = 5,
  Reload = 6,
  SucssefulyPlayedTicket = 7,
  TicketPlaceBetOddChanged = 8,
}

export enum TicketType {
  System = 1,
  ExpandedSystem = 2,
  Fix = 10,
  Single = 11,
  Sum = 12
}

export enum FreeBetProcessingType {
  None = 0,
  WonAmountWithoutStake = 1,
  WonAmountWithoutStakeAndStakeInWallet = 2,
  StakeOnly = 3,
  WonAmount = 4,
  WonAmountWithoutStakeWithoutBonus = 11,
  WonAmountWithoutStakeAndStakeInWalletWithoutBonus = 12,
  WonAmountWithoutBonus = 14
}

export enum BetTypeValueType {
  None = 0,
  Teams = 1,
  Players = 2,
  NumericValue = 3,
  LiveSpecialBetValue = 4
}

export enum RestrictionEntityTypes {
  Sport = 0,
  Region = 1,
  Competition = 2,
  Event = 3
}

export enum BetslipTypeBonusSetting {
  Accumulator = 0,
  Any = 1
}

export enum EventTypeBonusSetting {
  Prematch = 1,
  Live = 2,
  Both = 3
}

export enum MinimumEventOddMode {
  ApplyToWholeTicket = 0,
  ExcludeItemsWithLowerOdd = 1
}

export enum SportTreeCondition {
  None = 0,
  OnlySelected = 1,
  Minimum = 2
}

export enum BetslipTypeFreeBetSetting {
  Fix = 0,
  System = 1,
  Both = 2
}

export enum ElementState {
  Unchanged = 0,
  Added = 1,
  Deleted = 2,
  Updated = 3
}

export enum RESTServiceMessage {
  None = 0,
  Exception = 1,
  EventOffline = 2,
  LiveBetStopped = 3,
  TicketNotFound = 4,
  NotAuthorized = 5,
  LoginFailed = 6,
  SportsNotFilled = 7,
  BetTypeOutcomesNotFilled = 8,
  NoFreeOffice = 9,
  AssignOfficeId = 10,
  NotAuthorizedToAssignOfficeId = 11,
  OfficeIdAssigned = 12,
  OfficeIdNotAssigned = 13,
  TicketNotInPendingState = 14,
  TicketVoidPeriodElapsed = 15,
  TicketNotIsPassedState = 16,
  TicketPayoutTimeElapsed = 17,
  TransactionFailed = 18,
  InvalidUserPassword = 19,
  InvalidApprovedUserId = 20,
  ApprovedUserNotAuthorized = 21,
  InvalidPinCode = 22,
  TicketNotVerified = 23,
  TicketItemOddChanged = 24,
  PayoutNotAllowedForThatOffice = 25,
  AuthorizationTokenExpired = 26,
  InvalidTicketStatus = 27,
  TicketIsAutomaticallyRejected = 28,
  RiskServiceNotAvailable = 29,
  InvalidUser = 30,
  UserDoesntHavePermissions = 31,
  ThereAreOfflineBets = 32,
  ChangePasswordFailed = 33,
  TicketAutomaticallyRejected = 34,
  InsufficientFunds = 35,
  TicketSinglesOnlyRestrictionsFailedForSport = 36,
  TicketSinglesOnlyRestrictionsFailedForRegion = 37,
  TicketSinglesOnlyRestrictionsFailedForComptition = 38,
  TicketSinglesOnlyRestrictionsFailedForEvent = 39,
  PlatformError = 40,
  MaxEventsOnBetslipFailed = 41,
  MinStakePerBetslipFailed = 42,
  MinStakePerCombinationFailed = 43,
  CashoutValueChanged = 44,
  MaxTotalOdd = 45,
  MaxEventsInCombination = 46,
  MaxStake = 47,
  FreeBetConditionsAreNotFulfilled = 48,
  MinSelection = 51,
  MaxLeagueSelection = 52,
  SuperBetConditionsAreNotFulfilled = 53
}

export enum OfflineBetType {
  EventOffline = 0,
  BetOutcomeOffline = 1
}

export enum OddsValidationMode {
  None = 0,
  AcceptHigherOdds = 1,
  AcceptAllOdds = 2
}

export enum RequestSource {
  TicketManager = 1,
  Terminal = 2,
  Web = 3,
  Mobile = 4
}

export enum EventType {
  HeadToHead = 1,
  Outright = 2
}

export enum LeagueTimeFilterType {
  League = 'League',
  Time = 'Time'
}


export enum ComponentName {
  EventsComponent = 1,
  EventsComponentLive = 2,
  EventsHeaderComponent = 3,
  SportTreeComponent = 4,
  SportTreeSelectionContainerComponent = 5,
  SportsTreeBreadcrumbsComponent = 6,
  ResultsSportsSelectionContainerComponent = 7,
  ResultEventsHeaderComponent = 8,
  ResultsSportTreeComponent = 9

}

export enum TicketPlayType {
  ConfirmationTicket = 1,
  ChangedTicket = 2,
  PlayedTicket = 3,
  PlaceBet = 4
}


export enum EventsHeaderLiveButtonType {
  MainView = 1,
  MatchView = 2,
  Calendar = 3
}

export enum BetOrderingType {
  NoOrdering = 1,
  ByOddAscending = 2,
  ByOddDescending = 3
}

export enum NotificationType {
  CUSTOM = 0,
  MATCH_BEGIN = 1,
  MATCH_END = 2,
  PART_BEGIN = 3,
  PART_END = 4,
  POINT = 5,
  RED_CARD = 6,
  YELLOW_CARD = 7
}

export enum SiteViewConfiguration {
  SERBIA = 1,
  CROATIA = 2,
  BIH = 3,
  UGANDA = 4,
  NIGERIA = 5
}

export enum HomeAwayTO {
  HOME = 1,
  AWAY = 2
}

export enum HomeAway {
  NONE = 0,
  HOME = 1,
  AWAY = 2
}


export enum PlatformHeadrId {
  SERBIA = 'headerContainer',
  CROATIA = 'backHeaderContainer'
}

export enum UserType{
  STANDARD_USER = 1,
  CAHSIER = 2,
  ADMIN = 3
}


export enum TicketToolTab {
  TicketValidation = 1,
  CashierSearch = 2
}

export enum SuperbetMessageType{
  NONE = 0,
  MIN_NON_SB_ODD = 1,
  MIN_NON_SB_COUNT = 2,
  MIN_NON_SB_ODD_AND_COUNT = 3
}

export enum DATicketStatus {
  Reserve = 1,
  Return = 2,
  Open = 3,
  Void = 4,
  Storno = 5,
  Won = 6,
  Lost = 7,
  CashOut = 8,
  CashBack = 9,
  Paid = 10,
  CashBackPaid = 11,
  VoidPaid = 12,
  Expired = 13
}


export enum EventStatus{
  Offline = 0,
  Online = 1,
  Postponed = 2,
  Blocked = 3,
  Finished = 4,
  None = 5
}

export enum BetTypeOutcomeVisibilityType {
  Hidden = 1,
  ShowLocked = 2
}

export enum TicketStakeType {
  Regular = 1,
  FreeBet = 2,
  PlatformBonus = 3
}

export enum TicketBettingType {
  Regular = 1,
  Bonus = 2,
  LuckyWinner = 3,
  Virtual = 4
}

export enum GroupTypeList{
  None = 0,
  System = 1,
  SysytemInSystem = 2,
  MultipleOutcomes = 3,
  Fix = 10
}